import {version} from '../../../package.json';
import { namespace } from '../common/Utils';
import Footer from './index';

namespace('ncui');
if (!window.ncui.ver) window.ncui.ver = version;
window.ncui.footer = Footer;